<template>
  <div>  
    <div class="content-wrap">
      <header-component />
      <router-view />
    </div>

    <footer-component />
  </div>
</template>

<script>

import HeaderComponent from "./components/Header";
import FooterComponent from "./components/Footer";
import { onLogin, onLogout } from './vue-apollo';

export default {
  name: 'App',
  components: { HeaderComponent, FooterComponent },
  async created() {
    this.$store.state.isLoggedUserQueryDone = false
    await this.getUser();
    this.$store.state.isLoggedUserQueryDone = true
  },
  methods: {
    async getUser() {
      const result = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth");
      if (result && result.body && result.body.user) {
        await onLogin.apply(this, [this.$apollo.provider.defaultClient, result.body.user])
      } else {
        await onLogout.apply(this, [this.$apollo.provider.defaultClient])
      }
    },
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />